import { useStore } from 'vuex'

export function useAnalytics() {
  const store = useStore()

  const trackEvent = (eventName, params = {}, userEmail = null) => {
    store.dispatch('analytics/trackEvent', {
      eventName,
      params,
      userEmail
    })
  }

  const trackPage = (pageUrl, userEmail = null) => {
    store.dispatch('analytics/trackPage', {
      pageUrl,
      userEmail
    })
  }

  return {
    trackEvent,
    trackPage
  }
}